var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #63666f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4075",
    "data-name": "Group 4075",
    transform: "translate(6122 9114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1134",
    "data-name": "Rectangle 1134",
    className: "cls-1",
    width: 22,
    height: 22,
    transform: "translate(-6122 -9114)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-map",
    transform: "translate(-6119 -9114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M8.05,22a.457.457,0,0,1-.367-.18C7.606,21.722,0,11.9,0,7.709A7.894,7.894,0,0,1,8.05,0a7.9,7.9,0,0,1,8.055,7.709c0,4.108-7.369,13.7-7.683,14.111A.47.47,0,0,1,8.05,22Zm0-18.018A3.817,3.817,0,0,0,4.158,7.709,3.818,3.818,0,0,0,8.05,11.44a3.821,3.821,0,0,0,3.9-3.731A3.819,3.819,0,0,0,8.05,3.982Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.fed28124b1b16368c4e2d973a01488b7.svg";
export { ForwardRef as ReactComponent };